import { createTheme } from '@one-thd/sui-atomic-components';

const MakitaPrimary = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

MakitaPrimary.palette['--sui-palette-background-primary'] = '19 133 155';

export { MakitaPrimary };
